import * as React from 'react';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import Tooltip from 'components/Tooltip';
import UserAvatar from 'users/components/UserAvatar';

type Props = {
  user: any | undefined | null;
  avatarLabel: string;
  deliveryError: any | undefined | null;
};

export default class DeliveryModalSectionItem extends React.PureComponent<Props> {
  renderDeliveryError = (deliveryError: any, name: string) => {
    const tooltipCopy = {
      undelivered: `Your message may have been blocked by a spam filter or ${name} may have turned off their phone. Please try again.`,
      failed: `Your message may have been blocked by a spam filter or ${name} may have turned off their phone. Please try again.`,
      blocked: `${name} needs to turn on push notifications, text messages, or emails for Remind.`,
      expired: `Your message may have been blocked by a spam filter or ${name} may have turned off their phone. Please try again.`,
      invalid: `${name} may have mistyped their email or changed their phone number. They need to update their contact information.`,
      unsupported: `${name} has a mobile carrier that doesn’t receive text messages from Remind. They need to download the Remind app.`,
      missing_student:
        'There’s no student with this student number in your organization on Remind.',
      missing_parents: 'This student is missing a parent or guardian on Remind.',
    };
    return (
      <LayerTrigger
        noPointer
        layer={
          <Tooltip alignment="top" placement="left">
            {/* @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
            {tooltipCopy[deliveryError.code] ||
              `Something went wrong in delivering your message to ${name}.`}
          </Tooltip>
        }
      >
        <div>
          <MediaObject gutter="xsmall" figure="right">
            <Text color="apple" size="xxsmall">
              {deliveryError.message}
            </Text>
            <Glyph color="apple" name="help" solo />
          </MediaObject>
        </div>
      </LayerTrigger>
    );
  };

  render() {
    const { user, avatarLabel, deliveryError } = this.props;
    return (
      <div className="DeliveryModalSection-user">
        <MediaObject figure="right" center>
          <MediaObject center gutter="small">
            <UserAvatar size="small" user={user} />
            <Text truncate>{avatarLabel}</Text>
          </MediaObject>
          {deliveryError ? this.renderDeliveryError(deliveryError, avatarLabel) : <span />}
        </MediaObject>
      </div>
    );
  }
}
